/*  日文包  */
import jaLocale from 'element-ui/lib/locale/lang/ja';
const ry = {
    message: {
        /*  导航栏语言设定 */
        'headerMenu' : 'ネットワークディスク',
        'headerlangSelect' : '言語を選択してください',
        'headerLoginOut' : 'ログアウトする',

        /*  侧边栏语言设定 */
        'sideMenuFileName' : 'すべてのファイル',
        'sideMenuPhoto' : '写真',
        'sideMunsDoc' : 'ファイル',
        'sideMenuVideo' : '映像',
        'sideMenuSeed' : '種',
        'sideMenuMusic' : 'ミュージック',
        'sideMenuOrther' : 'その他',
        'sideMenuShareName' : '私の分け前',
        'sideMenuCollectName' : 'ごみ箱',

        /*  用户语言设定 */
        'mainUpload' : 'ファイルのアップロード',
        'mainBuildDir' : '新しいフォルダー',
        'mainDownloadOutline' : 'オフラインでダウンロード',
        'mainSearch' : 'ファイル検索',
        'mainAllFile' : 'すべてのファイル',
        'mainFile' : 'ファイル',
        'mainSize' : '大きさ',
        'mainDate' : '日付',
        'mainFileDel' : '削除',
        'mainConfirmDel' : '続行することを確認?',
        'sure' : '確認する',
        'cancel' : 'キャンセルする',
        'mainReturn' : 'に戻る',
        'mainPagePrev' : '前へ',
        'mainPageNext' : '次のページ',
        'mainLoaded' : 'ロード済み',
        'mainTotal' : '合計',
        'mainUnit' : 'ストリップ',
        'dilatation' : '拡張',
        /*  回收站设定  */
        'mainHeaderTitle' : 'ヒント：ごみ箱はネットワークディスク領域を占有しません。',
        'mainHeaderButton' : '空のごみ箱',
        'collectName' : 'ごみ箱',
        'mainRevertIts' : '復元する',
        'mianDelData' : '時間を削除',

        'confirmClear' : '選択したファイルをクリアすることを確認しますか？ （クリア後に回復できません）',
        'confirmClearAll' : 'ごみ箱を空にしてもよろしいですか？',

        /*  其他设定 */
        'messageBoxTitle' : 'ヒント',
        'messageBoxConfirmRevert' : '選択したファイルの復元を確認しますか？',
        'loading' : '読み込み中...',
        'loaded' : 'データなし',

        'messageMoveTo' : 'に移動',
        'filterNotice' : 'フィルタリングするキーワードを入力してください',
        'messageLoaded' : 'ダウンロード済み：',
        'messageMovetion' : 'ファイル移動',

        'messageMissKeyWord' : '検索キーワードを入力してください',
        'messageFolderLayersLimit' : '作成に失敗しましたフォルダー階層の深さが5レベルを超えていません',
        'messageSameFolderName' : '作成に失敗しました同じファイル名が存在します',
        'messageEmptyFolderName' : 'フォルダー名を入力してください',
        'messageMoveSame' : '同じフォルダーに移動できません',
        'messageActionError' : '操作に失敗しました',
        'messageActionSuccess' : '操作が成功しました',
        'messageServerIsBusy' : 'サーバーがビジーです',
        'messageUploadOverLimit' : '選択したファイルが多すぎます（5以内）',
        'messageDiskFreeFull' : '不十分なユーザースペース',
        'messageUploadTypeError' : 'このタイプのファイルをアップロードできません',
        'messageUploadMaxSize' : 'アップロードファイルが大きすぎます（10M以内）',
        'messageUploadSuccess' : 'アップロードしました',
        'messageUploadFailed' : 'アップロードに失敗しました',
        'messageDownloadFailed' : 'ダウンロードに失敗しました'
    },
    ...jaLocale
};

export default ry;



// WEBPACK FOOTER //
// ./src/i18n/langs/ry.js